export default __webpack_public_path__ + "static/media/sass-lang-icon.06bf8b60.svg";